import React from 'react';
import { Link } from 'react-router-dom';
import { UseAuth } from '../contexts/auth.context';
const Header = () => {
    let User = UseAuth().user;
    return (
        <header className="navbar navbar-inverse navbar-fixed-top">
            <ul className="nav navbar-nav-custom">
                <li>
                    <Link to="/">
                        <i className="fa fa-ellipsis-v fa-fw animation-fadeInRight" id="sidebar-toggle-mini"></i>
                        <i className="fa fa-bars fa-fw animation-fadeInRight" id="sidebar-toggle-full"></i>
                    </Link>
                </li>
                <li className="hidden-xs animation-fadeInQuick">
                    <Link to="/">
                        {User && (
                            <strong>
                                {User.firstName} {User.lastName}
                            </strong>
                        )}
                    </Link>
                </li>
            </ul>
        </header>
    );
};
export default Header;
